// src/components/CommonFooter.jsx
import React from 'react';
import './CommonFooter.css';
import config from '../config';
import logo from '../logo.svg'; 

const CommonFooter = ({ onNavigate, activePage }) => {
  const handleNavClick = (page) => {
    if (onNavigate) {
      onNavigate(page);
    }
  };

  const handleLegalPage = (path) => {
    window.location.href = path;
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="common-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <div className="footer-logo" onClick={() => handleNavClick('home')}>
              {/* <span className="logo-icon">📋</span> */}
              <img
                src={logo}
                alt={`${config.APP_NAME} Logo`}
                className="logo-icon"
                width="40"
                height="40"
              />
              <span className="logo-text">{config.APP_NAME}</span>
            </div>
            <p>Create beautiful forms and generate PDFs effortlessly.</p>
          </div>
          <div className="footer-col">
            <h4>Product</h4>
            <button onClick={() => handleNavClick('features')} className="footer-link">
              Features
            </button>
            <button onClick={() => handleNavClick('pricing')} className="footer-link">
              Pricing
            </button>
            <button onClick={() => handleNavClick('how-it-works')} className="footer-link">
              How It Works
            </button>
          </div>
          <div className="footer-col">
            <h4>Resources</h4>
            <button onClick={() => handleNavClick('blog')} className="footer-link">
              Blog
            </button>
            {/* <button onClick={() => handleNavClick('about')} className="footer-link">
              About Us
            </button> */}
            <button onClick={() => handleNavClick('contact')} className="footer-link">
              Contact Us
            </button>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <button onClick={() => handleNavClick('privacy')} className="footer-link">
              Privacy Policy
            </button>
            <button onClick={() => handleNavClick('terms')} className="footer-link">
              Terms of Service
            </button>
            <button onClick={() => handleNavClick('cookies')} className="footer-link">
              Cookie Policy
            </button>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} {config.APP_NAME}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default CommonFooter;